export const computeProfitPerYear = (
  profitabilityByYear: number,
  sharePrice: number,
  shareAmount: number
): number => {
  return (profitabilityByYear / 100) * (shareAmount * sharePrice);
};
